/**
 * Default SLIK Barber Lounge Service Structure
 *
 * Hierarchical service menu with categories, subcategories, and variations
 */

import { ServiceCategory } from '../services/hierarchicalServiceDataService';

export const defaultServiceStructure: Omit<ServiceCategory, 'id' | 'createdAt' | 'updatedAt'>[] = [
  {
    name: 'Haircuts',
    description: 'Professional haircut services tailored to your style',
    icon: '💈',
    sortOrder: 1,
    active: true,
    subcategories: [
      {
        id: 'classic-haircut',
        name: 'Classic Haircut',
        description: 'Timeless styles that never go out of fashion',
        active: true,
        variations: [
          {
            id: 'short-classic',
            name: 'Short Classic',
            description: 'Clean, professional short haircut',
            price: 35,
            duration: 30,
            active: true,
          },
          {
            id: 'medium-classic',
            name: 'Medium Length',
            description: 'Versatile medium-length classic cut',
            price: 40,
            duration: 35,
            active: true,
          },
          {
            id: 'long-classic',
            name: 'Long Hair',
            description: 'Stylish long hair cut and shaping',
            price: 45,
            duration: 40,
            active: true,
          },
        ],
      },
      {
        id: 'fade',
        name: 'Fade',
        description: 'Precision fade cuts for a sharp, modern look',
        active: true,
        variations: [
          {
            id: 'low-fade',
            name: 'Low Fade',
            description: 'Subtle fade starting low on the sides',
            price: 40,
            duration: 35,
            active: true,
          },
          {
            id: 'medium-fade',
            name: 'Medium Fade',
            description: 'Balanced fade at mid-level',
            price: 45,
            duration: 40,
            active: true,
          },
          {
            id: 'high-fade',
            name: 'High Fade',
            description: 'Bold high fade for maximum contrast',
            price: 45,
            duration: 40,
            active: true,
          },
        ],
      },
      {
        id: 'trendy',
        name: 'Trendy',
        description: 'Latest trending styles and cuts',
        active: true,
        variations: [
          {
            id: 'textured-crop',
            name: 'Textured Crop',
            description: 'Modern textured crop with styling',
            price: 50,
            duration: 30,
            active: true,
          },
          {
            id: 'pompadour',
            name: 'Pompadour',
            description: 'Classic pompadour with modern twist',
            price: 55,
            duration: 50,
            active: true,
          },
          {
            id: 'undercut',
            name: 'Undercut',
            description: 'Sharp undercut with long top',
            price: 50,
            duration: 45,
            active: true,
          },
        ],
      },
    ],
  },
  {
    name: 'Beard Services',
    description: 'Expert beard grooming and shaping',
    icon: '🧔',
    sortOrder: 2,
    active: true,
    subcategories: [
      {
        id: 'beard-trim',
        name: 'Beard Trim',
        description: 'Professional beard trimming and cleanup',
        active: true,
        variations: [
          {
            id: 'basic-trim',
            name: 'Basic Trim',
            description: 'Quick beard trim and edge up',
            price: 20,
            duration: 15,
            active: true,
          },
          {
            id: 'detailed-trim',
            name: 'Detailed Trim',
            description: 'Thorough trim with hot towel treatment',
            price: 30,
            duration: 25,
            active: true,
          },
        ],
      },
      {
        id: 'beard-shaping',
        name: 'Beard Shaping',
        description: 'Precision beard sculpting and design',
        active: true,
        variations: [
          {
            id: 'full-shaping',
            name: 'Full Beard Shaping',
            description: 'Complete beard shaping with line-up',
            price: 35,
            duration: 30,
            active: true,
          },
        ],
      },
    ],
  },
  {
    name: 'Specialty Services',
    description: 'Premium grooming experiences',
    icon: '⭐',
    sortOrder: 3,
    active: true,
    subcategories: [
      {
        id: 'specialty',
        name: 'Specialty Treatments',
        description: 'Exclusive grooming services',
        active: true,
        variations: [
          {
            id: 'hot-towel-shave',
            name: 'Hot Towel Shave',
            description: 'Luxurious straight razor shave with hot towels',
            price: 45,
            duration: 40,
            active: true,
          },
          {
            id: 'scalp-treatment',
            name: 'Scalp Treatment',
            description: 'Rejuvenating scalp massage and treatment',
            price: 35,
            duration: 30,
            active: true,
          },
          {
            id: 'full-grooming',
            name: 'Full Grooming Package',
            description: 'Complete haircut, beard, and hot towel service',
            price: 85,
            duration: 75,
            active: true,
          },
        ],
      },
    ],
  },
];
